import {colorYellow, darkGray, DEFAULT_THEME_OPTIONS, lightGray, nightGray} from "../shared/colors";
import {darken, ThemeOptions} from "@mui/material";

// Light theme
export const THEME_COLOR_PRIMARY_LIGHT = "#000";
export const THEME_COLOR_PRIMARY = "#000";
export const THEME_COLOR_PRIMARY_DARK = darken(THEME_COLOR_PRIMARY, 0.5);//"#001a4d";
export const THEME_COLOR_PRIMARY_CONTRAST = "#fff";
export const THEME_COLOR_SECONDARY = "#06f";
export const THEME_COLOR_SECONDARY_CONTRAST = "#fff";

// Dark theme
export const THEME_DARK_COLOR_PRIMARY_LIGHT = "#fff";
export const THEME_DARK_COLOR_PRIMARY = "#eee";
export const THEME_DARK_COLOR_PRIMARY_DARK = "#ccc";
export const THEME_DARK_COLOR_PRIMARY_CONTRAST = "#000";
export const THEME_DARK_COLOR_SECONDARY = "#06f";
export const THEME_DARK_COLOR_SECONDARY_CONTRAST = "#fff";

const HEADING_FONT = "Plus Jakarta Sans, sans-serif";
const BODY_FONT = "Inter, sans-serif";

export const THEME_OPTIONS_SHARED: ThemeOptions = {
  ...DEFAULT_THEME_OPTIONS,
  typography: {
    ...DEFAULT_THEME_OPTIONS.typography,
    h1: {
      fontWeight: "bold",
      letterSpacing: -1.3,
      fontFamily: HEADING_FONT,
    },
    h2: {
      fontWeight: "bold",
      letterSpacing: -1.2,
      fontFamily: HEADING_FONT,
    },
    h3: {
      fontWeight: "bold",
      letterSpacing: -1.1,
      fontFamily: HEADING_FONT,
    },
    h4: {
      fontWeight: "bold",
      fontFamily: HEADING_FONT,
    },
    h5: {
      fontWeight: "bold",
      fontFamily: HEADING_FONT,
    },
    h6: {
      fontWeight: "bold",
      fontFamily: HEADING_FONT,
    },
    fontFamily: BODY_FONT,
    fontSize: 14,
  },
  transitions: {
    duration: {
      enteringScreen: 100,
      leavingScreen: 100,
    }
  },
};

export const THEME_OPTIONS: ThemeOptions = {
  ...THEME_OPTIONS_SHARED,
  palette: {
    background: {
      paper: "white",
      // default: "#edf7ff",
      default: lightGray,
    },
    primary: {
      light: THEME_COLOR_PRIMARY_LIGHT,
      main: THEME_COLOR_PRIMARY,
      dark: THEME_COLOR_PRIMARY_DARK,
      contrastText: THEME_COLOR_PRIMARY_CONTRAST,
    },
    secondary: {
      main: THEME_COLOR_SECONDARY,
      contrastText: THEME_COLOR_SECONDARY_CONTRAST,
    },
  }
};

export const THEME_OPTIONS_DARK: ThemeOptions = {
  ...THEME_OPTIONS_SHARED,
  palette: {
    mode: "dark",
    background: {
      paper: darkGray,
      default: nightGray,
    },
    primary: {
      light: THEME_DARK_COLOR_PRIMARY_LIGHT,
      main: THEME_DARK_COLOR_PRIMARY,
      dark: THEME_DARK_COLOR_PRIMARY_DARK,
      contrastText: THEME_DARK_COLOR_PRIMARY_CONTRAST,
    },
    secondary: {
      main: THEME_DARK_COLOR_SECONDARY,
      contrastText: THEME_DARK_COLOR_SECONDARY_CONTRAST,
    },
  }
};
